import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogPosts } from '../data/blogData';
import './BlogList.css';

const BlogList = () => {
  return (
    <div className="blog-list-page">
      <Helmet>
        <title>Jajoga Insights | Salon & Franchise Analytics Blog</title>
        <meta name="description" content="Data-driven perspectives for modern salon operators. Learn about salon analytics, franchise management, and operational insights from Jajoga." />
        <link rel="canonical" href="https://jajoga.com/blog" />

        {/* Open Graph */}
        <meta property="og:title" content="Jajoga Insights | Salon Analytics Blog" />
        <meta property="og:description" content="Data-driven perspectives for modern salon operators. Learn about salon analytics, franchise management, and operational insights." />
        <meta property="og:url" content="https://jajoga.com/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://jajoga.com/images/hero-dashboard.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Jajoga Insights | Salon Analytics Blog" />
        <meta name="twitter:description" content="Data-driven perspectives for modern salon operators." />
        <meta name="twitter:image" content="https://jajoga.com/images/hero-dashboard.png" />

        {/* BreadcrumbList Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://jajoga.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog"
              }
            ]
          })}
        </script>
      </Helmet>
      <div className="blog-hero">
        <div className="container">
          <h1>Jajoga Insights</h1>
          <p>Data-driven perspectives for modern salon operators</p>
        </div>
      </div>

      <div className="blog-container">
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.slug} className="blog-card">
              <div className="blog-card-content">
                <span className="blog-category">{post.category}</span>
                <h2 className="blog-card-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-meta">
                  <span className="blog-date">{post.date}</span>
                  <span className="blog-read-time">{post.readTime}</span>
                </div>
                <Link to={`/blog/${post.slug}`} className="blog-read-more">
                  Read Article
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogList;
